export enum PhoneStatusEnum {
  Unbind = 'unbind',
  Bind = 'bind',
  Refused = 'refused',
}
